import { Button } from '@aircall/tractor-v2';
import styled from '@xstyled/styled-components';

import { ReactComponent as LogoAircallWhite } from '@assets/images/aircall_logo_white.svg';

export const LoginActionButton = styled(Button)`
  @media (width >= 575px) {
    width: 320px;
  }

  @media (width <= 575px) {
    width: 240px;
  }
`;

export const ScalableAircallLogo = styled(LogoAircallWhite)`
  @media (width >= 575px) {
    width: 187px;
    height: 56px;
  }
`;
